import { createBasicSelector } from 'util/redux'
import { selectCurrentConversationById } from '.'

export const selectConversationSnoozedUntilByConversationId = createBasicSelector(
  selectCurrentConversationById,
  ticket => ticket?.snoozed?.until
)
